const objectives = {
  addTarget: 'Ajouter une cible',
  addTargetPoint: 'Ajouter un point',
  aheadOfTarget: 'En avance sur {{name}} ({{expected}})',
  allObjectives: 'Tous les objectifs',
  archivedObjectives: 'Objectifs archivés',
  behindTarget: 'En retard sur {{name}} ({{expected}})',
  bestValue: 'Meilleure valeur',
  cancelledObjectives: 'Objectifs annulés',
  completeObjectives: 'Objectifs complétés',
  createAnObjective: 'Créer un objectif',
  currentValue: 'Valeur actuelle',
  durationFormat: 'Temps (h:mm:ss)',
  durationPlaceholder: 'h:mm:ss',
  distanceFromTarget: '{{distance}} de la cible',
  distanceFromTargetTrack: '{{distance}} de {{name}} ({{expected}})',
  failedObjectives: 'Objectifs échoués',
  goal: 'Objectif',
  goalFrequency: 'Fréquence',
  goalKind: 'Type d\'objectif',
  goalKindAround: 'Autour d\'une cible',
  goalKindHelpAROUND: 'Enregistrez la valeur à une date donnée. Plus elle est proche de la cible, mieux c\'est, par exemple un poids.',
  goalKindHelpHIGHEST: 'Enregistrez la valeur à une date donnée. Plus elle est haute, mieux c\'est, par exemple un solde ou une note cumulative.',
  goalKindHelpLOWEST: 'Enregistrez la valeur à une date donnée. Plus elle est basse, mieux c\'est.',
  goalKindHelpREACH: 'Enregistrez chaque pas vers l\'objectif. La dernière valeur est le progrès actuel.',
  goalKindHighest: 'Le plus haut possible',
  goalKindLowest: 'Le plus bas possible',
  goalKindReach: 'Atteindre un objectif',
  goalTolerance: 'Marge',
  incompleteObjectives: 'Objectifs non complétés',
  initialProgress: 'Progrès initial',
  invalidDuration: 'Indiquez une durée au format h:mm:ss, mm:ss ou en secondes',
  logProgress: 'Enregistrer la progression',
  noObjectivesToDisplay: 'Aucun objectif à afficher',
  noProgressEntries: 'Aucune progression enregistrée',
  noTargets: 'Aucune cible',
  noUnit: 'Aucune',
  objective: 'Objectif',
  objectiveAroundValue: '{{value}} (cible {{target}})',
  objectiveCreated: 'Objectif créé',
  objectiveDeleted: 'Objectif supprimé',
  objectiveHistoryAssigneeCleared: 'Responsable retiré',
  objectiveHistoryAssigneeSet: 'Responsable défini sur {{assignee}}',
  objectiveHistoryCompleted: 'Marqué comme terminé',
  objectiveHistoryDeadlineCleared: 'Échéance supprimée',
  objectiveHistoryDeadlineSet: 'Échéance définie au {{date}}',
  objectiveHistoryFormatCleared: 'Affichage en nombre',
  objectiveHistoryFormatSet: 'Affichage défini sur {{format}}',
  objectiveHistoryGoalFrequencyCleared: 'Fréquence supprimée',
  objectiveHistoryGoalFrequencySet: 'Fréquence définie sur {{frequency}}',
  objectiveHistoryGoalKindCleared: 'Type d\'objectif supprimé',
  objectiveHistoryGoalKindSet: 'Type d\'objectif défini à {{kind}}',
  objectiveHistoryProgressCleared: 'Progrès supprimé',
  objectiveHistoryProgressSet: 'Progrès défini à {{value}}',
  objectiveHistoryProjectsAssigned_one: 'Assigné au projet {{projects}}',
  objectiveHistoryProjectsAssigned_other: 'Assigné aux projets {{projects}}',
  objectiveHistoryProjectsUnassigned_one: 'Retiré du projet {{projects}}',
  objectiveHistoryProjectsUnassigned_other: 'Retiré des projets {{projects}}',
  objectiveHistoryReopened: 'Réouvert',
  objectiveHistoryStatusSet: 'Statut défini à {{status}}',
  objectiveHistoryUnitCleared: 'Unité supprimée',
  objectiveHistoryUnitSet: 'Unité définie à {{unit}}',
  objectives: 'Objectifs',
  objectiveUpdated: 'Objectif mis à jour',
  objectiveUpdatedFields: 'Mise à jour : {{fields}}',
  ongoingObjectives: 'Objectifs en cours',
  progressChartPoint: '{{date}} : {{value}}',
  progressOverTime: 'Progression dans le temps',
  recordedOn: 'Enregistré le',
  saveTargets: 'Enregistrer les cibles',
  target: 'Cible',
  targetName: 'Nom de la cible',
  targetPointValue: 'Valeur',
  targets: 'Cibles',
  unit: 'Unité',
  value: 'Valeur',
  xSelectedObjectives_one: '{{count}} objectif sélectionné',
  xSelectedObjectives_other: '{{count}} objectifs sélectionnés',
};

export default objectives;
